import _ from 'lodash';
import { serverToDisplayDate, serverToDisplayTimeSlot } from 'app/lib/format';
import { storeData } from 'app/lib/serverDataCache';

export const serverKeyMap = {
    ref: 'reference',
    submit: 'canSubmit'
};

export const serverValueMap = {
    slotEta: (value) => serverToDisplayDate(value),
    delay: (value) => value === 1,
    empty: (value) => value === 1 ? '1' : '0',
    rid: (value) => value === 1,
    submit: (value) => value === 1,
    unitKind: (value) => value && storeData('unitKind', value.code, value),
    dim: (value) => value && storeData('dim',value.desc, value),
    regDate: (value) => value.length && serverToDisplayDate(value),
    packagingUnity: (value) => value && value.trim()
};

export const serverUnitToClientMap = (unit) => {
    let u = {};
    _.each(unit, function(value, key) {
        key = serverKeyMap[key] || key;
        if (serverValueMap[key]) {
            value = serverValueMap[key](value);
        }
        u[key] = value;
    });
    return u;
};

export const serverUnitsToClientMap = (units) => {
    let _units = [];
    for (let unit of units) {
        let u = serverUnitToClientMap(unit);
        _units.push(u);
    }
    return _units;
};

export const serverVisitToClientMap = (visit) => {
    let _units = [],
        _visit = {};

    if (visit.slotFrom) {
        _visit.timeslot = serverToDisplayTimeSlot(visit.slotFrom, visit.slotTo);
    }

    _.each(visit, function(value, key) {
        key = serverKeyMap[key] || key;
        if (serverValueMap[key]) {
            value = serverValueMap[key](value);
        }
        _visit[key] = value;
    });

    if (visit.units) {
        for (let unit of visit.units) {
            let u = serverUnitToClientMap(unit);
            _units.push(u);
        }
        _visit.units = _units;
    }

    return _visit;
};

export const serverGoodToClientMap = (good) => {
    let _good;

    if (_.isArray(good)) {
        _good = [];
        _.each(good, function (value){
            _good.push(serverGoodToClientMap(value));
        });
    } else {
        _good = {};
        _.each(good, function (value, key) {
            if (serverValueMap[key]) {
                value = serverValueMap[key](value);
            }
            _good[key] = value;
        });
    }

    return _good;
};

export const serverDocToClientMap = (doc) => {
    let _doc;
    
    if (_.isArray(doc)) {
        _doc = [];
        _.each(doc, function (value){
            _doc.push(serverDocToClientMap(value));
        });
    } else {
        _doc = {};
        _.each(doc, function (value, key) {
            if (serverValueMap[key]) {
                value = serverValueMap[key](value);
            }
            _doc[key] = value;
        });
    }
    
    return _doc;
};